import { useState, useEffect } from "react";

import {
  Box,
  Icon,
  SimpleGrid,
  useColorModeValue,
  Text,
  Portal,
  useDisclosure,
} from "@chakra-ui/react";
import Information from "views/admin/profile/components/Information";

import { SidebarContext } from "contexts/SidebarContext";

import React from "react";

import Loader from "components/Loader";
import Navbar from "components/navbar/NavbarAdmin.js";

import Card from "components/card/Card";

import { useNavigate } from "react-router-dom";
import Sidebar from "components/sidebar/Sidebar.js";
import {
  getActiveRoute,
  getActiveNavbar,
  getActiveNavbarText,
} from "helper/UploadFilePageHelper";

import routes from "routes.js";

import { MdHome, MdAccountBalance } from "react-icons/md";

import {
  FaNotesMedical,
  FaMoneyCheck,
  FaScroll,
  FaUserFriends,
  FaPollH,
  FaElementor,
  FaFontAwesome,
} from "react-icons/fa";

// import { supabase } from "supabase/supabaseClient";

import { scrollToTextContent } from "./helper";

const api_url = process.env.REACT_APP_API;

export default function SelectModulePage() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const { onOpen } = useDisclosure();

  const [documentTypes, setDocumentTypes] = useState();

  const [selectedDocumentTypeID, setSelectedDocumentTypeID] = useState(null);
  const [selectedDocumentType, setSelectedDocumentType] = useState(null);

  useEffect(() => {
    // Demo: Use static data for document types (updated structure)
    const demoModules = [
      {
        "type": "Health Care",
        "description": "Forms related to Medical Industry.",
        "modules": [
            // # {
            // #     "id": 1,
            // #     "name": "Application for exemption governmentally owned property",
            // #     "description": "Application for exemption governmentally owned property",
            // #     "location": "",
            // #     "isActive": false,
            // # },
            // # {
            // #     "id": 2,
            // #     "name": "Assessment Worksheet Request Form",
            // #     "description": "Assessment Worksheet Request Form",
            // #     "location": "",
            // #     "isActive": false,
            // # },
            // # {
            // #     "id": 3,
            // #     "name": "Custom Document",
            // #     "description": "Custom Document",
            // #     "location": "",
            // #     "isActive": false,
            // # },
            // # {
            // #     "id": 4,
            // #     "name": "Managed Care Contract",
            // #     "description": "Managed Care Contract",
            // #     "location": "",
            // #     "isActive": false,
            // # },
            {
                "id": 5,
                "name": "Private Health Services Plan Agreement",
                "description": "Private Health Services Plan Agreement",
                "location": "",
                "isActive": true,
            },
        ],
    },
    {
        "type": "Tax Forms",
        "description": "Forms related to tax reporting and compliance.",
        "modules": [
            {
                "id": 37,
                "name": "Form 1040 Parser",
                "description": "Extracts information from the individual income tax return form (Form 1040).",
                "location": "eu and us",
                "isActive": false,
            },
            {
                "id": 38,
                "name": "Form 1099-DIV Parser",
                "description": "Extracts information from Form 1099-DIV, related to dividend income.",
                "location": "eu and us",
                "isActive": false,
            },
            {
                "id": 39,
                "name": "Form 1099-G Parser",
                "description": "Extracts information from Form 1099-G, related to government payments and tax refunds.",
                "location": "eu and us",
                "isActive": false,
            },
            {
                "id": 40,
                "name": "Form 1099-INT Parser",
                "description": "Extracts information from Form 1099-INT, related to interest income.",
                "location": "eu and us",
                "isActive": false,
            },
            {
                "id": 41,
                "name": "Form 1099-MISC Parser",
                "description": "Extracts information from Form 1099-MISC, related to miscellaneous income.",
                "location": "eu and us",
                "isActive": false,
            },
            {
                "id": 6,
                "name": "Form 1099-R Parser",
                "description": "Extracts information from Form 1099-R, related to retirement income.",
                "location": "eu and us",
                "isActive": false,
            },
            {
                "id": 7,
                "name": "Form SSA-1099 Parser",
                "description": "Extracts information from Form SSA-1099, related to Social Security benefits.",
                "location": "eu and us",
                "isActive": false,
            },
            {
                "id": 8,
                "name": "Form W2 Parser",
                "description": "Extracts information from Form W-2, related to wage and tax statements.",
                "location": "eu and us",
                "isActive": false,
            },
            {
                "id": 9,
                "name": "Form W9 Parser",
                "description": "Extracts information from Form W-9, related to taxpayer identification.",
                "location": "eu and us",
                "isActive": false,
            },
        ],
    },
    {
        "type": "Business and Partnership Tax Forms",
        "description": "Forms related to business and partnership income tax reporting.",
        "modules": [
            {
                "id": 10,
                "name": "Form 1065 Parser",
                "description": "Extracts information from Form 1065, related to partnership income.",
                "location": "eu and us",
                "isActive": false,
            },
            {
                "id": 11,
                "name": "Form 1120 Parser",
                "description": "Extracts information from Form 1120, related to corporate income tax.",
                "location": "eu and us",
                "isActive": false,
            },
            {
                "id": 12,
                "name": "Form 1120S Parser",
                "description": "Extracts information from Form 1120S, related to S corporation income tax.",
                "location": "eu and us",
                "isActive": false,
            },
        ],
    },
    {
        "type": "Investment and Retirement Tax Forms",
        "description": "Forms related to investment and retirement income tax reporting.",
        "modules": [
            {
                "id": 13,
                "name": "Form 1040-D Parser",
                "description": "Extracts information from Form 1040 Schedule D, related to capital gains and losses.",
                "location": "eu and us",
                "isActive": false,
            },
            {
                "id": 14,
                "name": "Form 1040-E Parser",
                "description": "Extracts information from Form 1040 Schedule E, related to rental income and expenses.",
                "location": "eu and us",
                "isActive": false,
            },
            {
                "id": 15,
                "name": "Investment and Retirement Statement Parser",
                "description": "Extracts information from investment and retirement account statements.",
                "location": "eu and us",
                "isActive": false,
            },
        ],
    },
    {
        "type": "Financial Documents",
        "description": "Forms related to financial documents and statements.",
        "modules": [
            {
                "id": 16,
                "name": "Bank Statement Parser",
                "description": "Extracts information from bank statements.",
                "location": "eu and us",
                "isActive": false,
            },
            {
                "id": 17,
                "name": "Mortgage Statement Parser",
                "description": "Extracts information from mortgage statements.",
                "location": "eu and us",
                "isActive": false,
            },
            {
                "id": 18,
                "name": "Pay Slip Parser",
                "description": "Extracts information from pay slips.",
                "location": "eu and us",
                "isActive": false,
            },
        ],
    },
    {
        "type": "Legal and Identity Documents",
        "description": "Forms related to legal and identity documents.",
        "modules": [
            {
                "id": 19,
                "name": "France Driver License Parser",
                "description": "Extracts information from French driver's licenses.",
                "location": "eu and us",
                "isActive": false,
            },
            {
                "id": 20,
                "name": "France National ID Parser",
                "description": "Extracts information from French ID cards.",
                "location": "eu and us",
                "isActive": false,
            },
            {
                "id": 21,
                "name": "France Passport Parser",
                "description": "Extracts information from French passports.",
                "location": "eu and us",
                "isActive": false,
            },
            {
                "id": 22,
                "name": "Identity Document Proofing",
                "description": "Predicts the validity of ID documents using multiple signals.",
                "location": "eu and us",
                "isActive": false,
            },
            {
                "id": 23,
                "name": "US Driver License Parser",
                "description": "Extracts information from US driver's licenses.",
                "location": "eu and us",
                "isActive": true,
            },
            {
                "id": 24,
                "name": "US Passport Parser",
                "description": "Extracts information from US passports.",
                "location": "eu and us",
                "isActive": false,
            },
        ],
    },
    {
        "type": "Invoices and Statements",
        "description": "Forms related to invoices and financial statements.",
        "modules": [
            {
                "id": 25,
                "name": "Expense Parser",
                "description": "Extracts information from receipts.",
                "location": "eu and us",
                "isActive": false,
            },
            {
                "id": 26,
                "name": "Invoice Parser",
                "description": "Extracts information from invoices.",
                "location": "eu and us",
                "isActive": false,
            },
            {
                "id": 27,
                "name": "Utility Parser",
                "description": "Extracts information from utility statements.",
                "location": "eu and us",
                "isActive": false,
            },
            {
                "id": 28,
                "name": "HOA Statement Processor",
                "description": "Extracts information from Homeowners Association statements.",
                "location": "eu and us",
                "isActive": false,
            },
            {
                "id": 29,
                "name": "Lending Doc Splitter/Classifier",
                "description": "Identifies and classifies lending document types.",
                "location": "eu and us",
                "isActive": false,
            },
            {
                "id": 30,
                "name": "Procurement Doc Splitter",
                "description": "Splits procurement documents bundled into a single PDF file.",
                "location": "eu and us",
                "isActive": false,
            },
            {
                "id": 31,
                "name": "Purchase Order Parser",
                "description": "Extracts information from purchase orders.",
                "location": "eu and us",
                "isActive": false,
            },
        ],
    },
    {
        "type": "Real Estate and Housing",
        "description": "Forms related to real estate and housing.",
        "modules": [
            {
                "id": 32,
                "name": "Extract from HOA statements",
                "description": "Extracts information from Homeowners Association statements.",
                "location": "eu and us",
                "isActive": false,
            },
            {
                "id": 33,
                "name": "Extract whether the signature and dates are populated in HUD 92900B",
                "description": "Extracts information related to HUD 92900B forms.",
                "location": "eu and us",
                "isActive": false,
            },
        ],
    },
    {
        "type": "Miscellaneous",
        "description": "Miscellaneous forms and document processing modules.",
        "modules": [
            {
                "id": 34,
                "name": "Extract over 50 fields from Fannie Mae Form 1003 (URLA)",
                "description": "Extracts information from Fannie Mae Form 1003 (URLA).",
                "location": "eu and us",
                "isActive": false,
            },
            {
                "id": 35,
                "name": "Predict the validity of ID documents using multiple signals",
                "description": "Provides ID document validity prediction.",
                "location": "eu and us",
                "isActive": false,
            },
            {
                "id": 36,
                "name": "Extract structured information from VBA26-0551 forms",
                "description": "Extracts information from VBA26-0551 forms.",
                "location": "eu and us",
                "isActive": false,
            },
        ],
    }
    ];
    setDocumentTypes(demoModules);
    setLoading(false);
  }, []);

  // ---------------------------
  // Chakra Color Mode

  const textColorPrimary = useColorModeValue("secondaryGray.900", "white");
  const textColorSecondary = "gray.400";
  const cardShadow = useColorModeValue(
    "0px 18px 40px rgba(112, 144, 176, 0.12)",
    "unset"
  );
  const typeToIcon = {
    "Health Care": FaNotesMedical, // Change "Type1" to the actual value in your data
    "Tax Forms": FaMoneyCheck,
    "Business and Partnership Tax Forms": FaScroll,
    "Investment and Retirement Tax Forms": FaUserFriends,
    "Financial Documents": FaPollH,
    "Legal and Identity Documents": MdAccountBalance,
    "Invoices and Statements": FaElementor,
    "Real Estate and Housing": MdHome,
    Miscellaneous: FaFontAwesome,
  };

  return (
    <>
      {loading ? (
        <Loader />
      ) : (
        <Box>
          <Box>
            <SidebarContext.Provider>
              <Sidebar />
              <Box
                float="right"
                minHeight="100vh"
                height="100%"
                overflow="auto"
                position="relative"
                maxHeight="100%"
                w={{ base: "100%", xl: "calc( 100% - 290px )" }}
                maxWidth={{ base: "100%", xl: "calc( 100% - 290px )" }}
                transition="all 0.33s cubic-bezier(0.685, 0.0473, 0.346, 1)"
                transitionDuration=".2s, .2s, .35s"
                transitionProperty="top, bottom, width"
                transitionTimingFunction="linear, linear, ease"
              >
                <Portal>
                  <Box>
                    <Navbar
                      onOpen={onOpen}
                      logoText={"Horizon UI Dashboard PRO"}
                      brandText={getActiveRoute(routes)}
                      secondary={getActiveNavbar(routes)}
                      message={getActiveNavbarText(routes)}
                      fixed={false}
                      navbarHeading="Modules"
                      // {...rest}
                    />
                  </Box>
                </Portal>
                <Box
                  mx="auto"
                  p={{ base: "20px", md: "30px" }}
                  pe="20px"
                  minH="100vh"
                  pt="50px"
                >
                  <Box pt={{ base: "130px", md: "80px", xl: "80px" }}>
                    {documentTypes.map((data, i) => (
                      <Card mb={{ base: "20px", "2xl": "20px" }} key={data.type}>
                        <Icon
                          as={typeToIcon[data.type]}
                          width="22px"
                          height="22px"
                          color="#422AFB"
                        />
                        <Text
                          color={textColorPrimary}
                          fontWeight="bold"
                          fontSize="2xl"
                          mt="8px"
                          mb="4px"
                        >
                          {data.type}
                        </Text>
                        <Text
                          color={textColorSecondary}
                          fontSize="md"
                          me="26px"
                          mb="40px"
                        >
                          {data.description}
                        </Text>
                        <SimpleGrid columns="3" gap="20px">
                          {data.modules.map((module, i) => (
                            <Information
                              key={module.id}
                              boxShadow={cardShadow}
                              title={module.description}
                              // description={module.description}
                              value={module.name}
                              id={module.id}
                              isActive={module.isActive}
                              selectedDocumentTypeID={selectedDocumentTypeID}
                              onClick={() => {
                                setSelectedDocumentType(module);
                                setSelectedDocumentTypeID(module.id);
                              }}
                              onClickIcon={() => {
                                // getFilesFromBucket(module.id);
                                navigate(`/module-files-upload-page`, {
                                  state: {
                                    selectedDocumentTypeID: module.id,
                                    selectedDocumentType: [module],
                                  },
                                });
                              }}
                            />
                          ))}
                        </SimpleGrid>
                      </Card>
                    ))}
                  </Box>
                </Box>
              </Box>
            </SidebarContext.Provider>
          </Box>
        </Box>
      )}
    </>
  );
}
